.calendarWeekRow {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 50px;
  width: 350px;
}
